import classNames from 'classnames'

import { Image } from 'wordpress/components'

import styles from '../styles/Subscribe.module.scss'

const SubscribeBackground = ({ subscribeTitle, defaults, subscribeForm }) => {
    const { backgroundImage } = defaults
    return (
        <Image
            className={classNames(styles.subscribe__image, 'd-flex', 'align-items-center', 'justify-content-center')}
            image={backgroundImage}
            background>
            <div className="row no-gutters justify-content-center w-100">
                <div className="col-12">{subscribeTitle()}</div>
                <div className="col-lg-4 col-md-5 col-sm-7 mt-4">{subscribeForm}</div>
            </div>
        </Image>
    )
}

export default SubscribeBackground
